import {GET_ALL_GAS_STATION_ZONES_FOR_BILLING, GET_ALL_PARKING_ZONES_FOR_BILLING, SET_LOADER} from "./types";
import {apiService} from "../utils/serviceApi";
import {createDocumentErrorNotification} from "../common/notifications/notification";
import {downloadFile, PINNED_FILE_NAME} from "../utils/downloadFile";

export const calculatePzList = (data) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
    .getDocumentPost(`${process.env.REACT_APP_SERVICE_URL}/api/parking-zone/calculatePzList`, data)
    .then((response) => {
      return downloadFile(response, "PZL.csv", PINNED_FILE_NAME);
    })
    .catch((e) => {
      createDocumentErrorNotification(e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};
export const calculateGsList = (data) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
      .getDocumentPost(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/calculateGsList`, data)
      .then((response) => {
        return downloadFile(response, "GSL.csv", PINNED_FILE_NAME);
      })
      .catch((e) => {
        createDocumentErrorNotification(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
};

export const calculateTicketList = (data) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
    .getDocumentPost(`${process.env.REACT_APP_SERVICE_URL}/api/parking-zone/calculateTicketList`, data)
    .then((response) => {
      return downloadFile(response, "ticketLists.zip", PINNED_FILE_NAME);
    })
    .catch((e) => {
      createDocumentErrorNotification(e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const calculateGsTicketList = (data) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
      .getDocumentPost(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/calculateTicketList`, data)
      .then((response) => {
        return downloadFile(response, "ticketLists.zip", PINNED_FILE_NAME);
      })
      .catch((e) => {
        createDocumentErrorNotification(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
};

export const getAllPzOptions = (country) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
    .post(`${process.env.REACT_APP_SERVICE_URL}/api/parking-zone/admin`, {country})
    .then((response) => {
      if (response.status === 200) {
        dispatch({
          type: GET_ALL_PARKING_ZONES_FOR_BILLING,
          payload: response.data,
        });
      }
    })
    .catch((e) => {
      console.log(e);
    })
    .finally(() => {
      dispatch({
        type: SET_LOADER,
        payload: false,
      });
    });
};

export const getAllGsOptions = (country) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
      .post(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/admin`, {country})
      .then((response) => {
        if (response.status === 200) {
          dispatch({
            type: GET_ALL_GAS_STATION_ZONES_FOR_BILLING,
            payload: response.data,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
};

export const calculateGsXMLTicketList = (data) => async (dispatch) => {
  dispatch({
    type: SET_LOADER,
    payload: true,
  });
  return apiService
      .getDocumentPost(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/calculateGsXML`, data)
      .then((response) => {
        return downloadFile(response, "ticketList.xml", PINNED_FILE_NAME);
      })
      .catch((e) => {
        createDocumentErrorNotification(e);
      })
      .finally(() => {
        dispatch({
          type: SET_LOADER,
          payload: false,
        });
      });
};

export const calculateGsSAPTicketList = (data) => async (dispatch) => {
    dispatch({
        type: SET_LOADER,
        payload: true,
    });
    return apiService
        .getDocumentPost(`${process.env.REACT_APP_SERVICE_URL}/api/gas-station/calculateGsSAP`, data)
        .then((response) => {
              return downloadFile(response, "sap.csv", PINNED_FILE_NAME);
        })
        .catch((e) => {
            createDocumentErrorNotification(e);
        })
        .finally(() => {
            dispatch({
                type: SET_LOADER,
                payload: false,
            });
        });
};